export interface TourInformationCategory {
  id: number;
  foreignId: number;
  name: string;
  translationKey: string;
}

export const TOUR_INFORMATION_CATEGORIES: TourInformationCategory[] = [
  {
    id: 12,
    foreignId: 76,
    name: '관광지',
    translationKey: 'spots',
  },
  {
    id: 14,
    foreignId: 78,
    name: '문화시설',
    translationKey: 'culture',
  },
  {
    id: 15,
    foreignId: 85,
    name: '축제공연행사',
    translationKey: 'festival',
  },
  {
    id: 25,
    foreignId: 25, // 다국어 미사용
    name: '여행코스',
    translationKey: 'course',
  },
  {
    id: 28,
    foreignId: 75,
    name: '레포츠',
    translationKey: 'sports',
  },
  {
    id: 32,
    foreignId: 80,
    name: '숙박',
    translationKey: 'accommodation',
  },
  {
    id: 38,
    foreignId: 79,
    name: '쇼핑',
    translationKey: 'shopping',
  },
  {
    id: 39,
    foreignId: 82,
    name: '음식점',
    translationKey: 'restaurant',
  },
] as const;

export const getCategories = (locale: string) => {
  // locale이 ko인 경우 id != 0인 카테고리만,
  // 그 외에는 foreignId != 0인 카테고리만 필터
  return Array.from(TOUR_INFORMATION_CATEGORIES).filter((category) => {
    if (locale.includes('ko-KR')) {
      return category.id !== 77;
    } else {
      return category.foreignId !== 25;
    }
  });
};

export const getContentId = (translationKey: string, locale: string) => {
  if (locale.includes('ko-KR')) {
    return TOUR_INFORMATION_CATEGORIES.find(
      (category) => category.translationKey === translationKey,
    )?.id;
  } else {
    return TOUR_INFORMATION_CATEGORIES.find(
      (category) => category.translationKey === translationKey,
    )?.foreignId;
  }
};
